module.exports = __webpack_public_path__ + "img/Subtipswarn.e983ddfa.svg";